<template>
  <v-row class="mt-0" align-center>
    <v-col xs11>
      <div v-for="(filter, key, index) of caseFilters" :key="key" class="filter-chip">
        <app-chip
          :key="filter.label"
          removable
          :max-width="500"
          :name="filter.label + ':' + joinedFilterValuesText(filter.value)"
          :right-margin="false"
          @removed="removeFilter(key)"
        >
          <span>{{ filter.label }}:&nbsp;</span>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="joinedFilterValues(filter.value)" />
        </app-chip>
        <span v-if="index !== filtersLength - 1">{{ delimiter }}</span>
      </div>

      <span v-if="filtersLength > 0 && tagFiltersLength > 0">{{ delimiter }}</span>

      <div v-for="(filter, index) of caseTagFilters" :key="index" class="filter-chip">
        <app-chip
          :key="filter"
          removable
          :max-width="500"
          :name="filter"
          :right-margin="false"
          @removed="removeTagFilter(filter)"
        >
          {{ filter }}
        </app-chip>
        <span v-if="index !== tagFiltersLength - 1">{{ delimiter }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { REMOVE_SINGLE_FILTER, REMOVE_SINGLE_TAG_FILTER } from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    pageKey: { type: String, required: true },
    delimiter: { type: String, default: 'and ' }
  },
  computed: {
    ...mapGetters(['getFilterByPageKey', 'getTagFilterByPageKey']),
    caseFilters() {
      return this.getFilterByPageKey(this.pageKey)
    },
    caseTagFilters() {
      return this.getTagFilterByPageKey(this.pageKey)
    },
    filtersLength() {
      return _.keys(this.caseFilters).length
    },
    tagFiltersLength() {
      return this.caseTagFilters ? this.caseTagFilters.length : 0
    }
  },
  methods: {
    removeFilter(key) {
      this.$store.dispatch(REMOVE_SINGLE_FILTER, { pageKey: this.pageKey, filterId: key })
      this.$emit('remove')
    },
    removeTagFilter(key) {
      this.$store.dispatch(REMOVE_SINGLE_TAG_FILTER, { pageKey: this.pageKey, tagFilterName: key })
      this.$emit('remove')
    },
    joinedFilterValues(filters) {
      return filters.map(filter => `<strong>${filter.text || filter}</strong>`).join(' or ')
    },
    joinedFilterValuesText(filters) {
      return filters.map(filter => `'${filter.text || filter}'`).join(' or ')
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-chip {
  display: inline;
}
</style>
